import { Box, Chip, Stack, Typography } from '@dtx-company/design-system/src'
import { ChipIcon } from './subcomponents/ChipIcon'
import { FilledLinkToWebField, asText } from '@prismicio/client'
import { IconComponent } from '@dtx-company/design-system/src/types/util'
import { chipClasses } from '@mui/material'
import { useLOCGPrismicContext } from '../hooks/useLOCGPrismicContext'
import React, { FC } from 'react'

export const GeneratorHeading: FC = () => {
  const { locgV2Data } = useLOCGPrismicContext()

  return (
    <>
      {/* Mobile */}
      <Box
        sx={theme => ({
          display: { xs: 'block', md: 'none' },
          p: theme.spacing(5, 10.5),
          boxShadow: 'inset 0px 1px 2px 0px rgba(0,0,0,.1)'
        })}
      >
        <Typography component="h1" variant="subtitleMedium" align="center">
          {asText(locgV2Data.page_title__mobile)}
        </Typography>
      </Box>

      {/* Desktop */}
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{ display: { xs: 'none', md: 'flex' }, my: 2, px: 4 }}
      >
        <Typography component="h1" variant="headlineLarge">
          {asText(locgV2Data.page_title__desktop)}
        </Typography>
        <Stack
          alignItems="end"
          gap={2}
          sx={{
            display: {
              md: 'none',
              lg: 'flex'
            },
            [`& .${chipClasses.root}`]: {
              maxWidth: 'unset',
              cursor: 'pointer',
              img: {
                ml: 2,
                mr: 1
              }
            }
          }}
        >
          {locgV2Data.heading_chip.map(({ text, icon, link }) => (
            <Chip
              key={text}
              component="a"
              href={(link as FilledLinkToWebField).url}
              target="_blank"
              variant="outlined"
              startIcon={ChipIcon.bind(null, { icon }) as unknown as IconComponent}
              label={text}
            />
          ))}
        </Stack>
      </Stack>
    </>
  )
}
